import { Box, Tag } from '@factorialco/deprecated-design-system'
import { TrainingsSessionAttendanceStatusEnum } from 'generated/resources/graphql'

import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

type Props = {
  status: TrainingsSessionAttendanceStatusEnum
}

export const SessionMembershipStatusTag = ({ status }: Props) => {
  const { getSessionAttendanceColor, getSessionAttendanceTranslation } = useTrainingsDatatable()

  return (
    <Box width="fit-content">
      <Tag type={getSessionAttendanceColor(status)}>{getSessionAttendanceTranslation(status)}</Tag>
    </Box>
  )
}
